import React from 'react';
import Icon from '../../../components/AppIcon';

/**
 * Cartes de statistiques pour les factures en retard
 */
const OverdueStatisticsCards = ({ stats, formatCurrency, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="bg-card border border-border rounded-lg p-6 animate-pulse">
            <div className="h-4 bg-muted rounded w-3/4 mb-3" />
            <div className="h-8 bg-muted rounded w-1/2 mb-2" />
            <div className="h-3 bg-muted rounded w-full" />
          </div>
        ))}
      </div>
    );
  }

  const statisticsCards = [
    {
      label: 'Total en retard',
      value: stats.totalOverdue,
      subtitle: `${stats.totalInvoices} facture${stats.totalInvoices > 1 ? 's' : ''} + ${stats.totalPhases} phase${stats.totalPhases > 1 ? 's' : ''}`,
      icon: 'AlertTriangle',
      iconColor: 'text-destructive',
      bgColor: 'bg-destructive/10',
      borderColor: 'border-destructive/20'
    },
    {
      label: 'Montant en retard',
      value: formatCurrency(stats.totalAmountOverdue, stats.currency),
      subtitle: stats.currency ? 'Solde total dû' : 'Solde total dû (devises mélangées)',
      icon: 'DollarSign',
      iconColor: 'text-destructive',
      bgColor: 'bg-destructive/10',
      borderColor: 'border-destructive/20',
      showCurrencyIndicator: !stats.currency // Show indicator when mixed currencies
    },
    {
      label: 'Retard moyen',
      value: `${stats.averageDaysOverdue}`,
      subtitle: `jour${stats.averageDaysOverdue > 1 ? 's' : ''} en moyenne`,
      icon: 'Clock',
      iconColor: 'text-warning',
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/20'
    },
    {
      label: 'Par gravité',
      value: (
        <div className="flex flex-col gap-1">
          <div className="flex items-center justify-between text-xs">
            <span className="text-warning">Attention:</span>
            <span className="font-bold text-foreground">{stats.bySeverity.warning}</span>
          </div>
          <div className="flex items-center justify-between text-xs">
            <span className="text-orange-500">Urgent:</span>
            <span className="font-bold text-foreground">{stats.bySeverity.urgent}</span>
          </div>
          <div className="flex items-center justify-between text-xs">
            <span className="text-destructive">Critique:</span>
            <span className="font-bold text-foreground">{stats.bySeverity.critical}</span>
          </div>
        </div>
      ),
      subtitle: 'Répartition des niveaux',
      icon: 'BarChart3',
      iconColor: 'text-primary',
      bgColor: 'bg-primary/10',
      borderColor: 'border-primary/20',
      customValue: true
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statisticsCards.map((card, index) => (
        <div
          key={index}
          className={`bg-card border rounded-lg p-6 hover:shadow-md transition-shadow ${card.borderColor}`}
        >
          <div className="flex items-start justify-between mb-3">
            <div className="flex-1">
              <p className="text-sm text-muted-foreground mb-1">{card.label}</p>
              {card.customValue ? (
                <div className="mb-2">{card.value}</div>
              ) : (
                <p className="text-2xl font-bold text-foreground mb-1">{card.value}</p>
              )}
              <p className="text-xs text-muted-foreground">{card.subtitle}</p>
              {card.showCurrencyIndicator && (
                <div className="mt-2 flex items-center gap-1 text-xs text-warning">
                  <Icon name="AlertCircle" size={12} />
                  <span>Sélectionnez un pays pour voir la devise</span>
                </div>
              )}
            </div>
            <div className={`p-3 rounded-lg ${card.bgColor}`}>
              <Icon name={card.icon} size={20} className={card.iconColor} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OverdueStatisticsCards;